import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-visionboard-tutorial',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './visionboard-tutorial.component.html',
  styleUrls: ['./visionboard-tutorial.component.scss']
})
export class VisionboardTutorialComponent implements OnInit {
  @Output() closeEvent = new EventEmitter<void>();
  @Output() finishTutorialEvent = new EventEmitter<void>();
  
  currentStep: number = 0;
  totalSteps: number = 3;
  isVisible: boolean = true;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  nextStep(): void {
    if (this.currentStep < this.totalSteps) {
      this.currentStep++;
    } else {
      this.finishTutorial();
    }
  }

  skipTutorial(): void {
    this.isVisible = false;
    this.closeEvent.emit();
  }

  finishTutorial(): void {
    this.isVisible = false;
    this.finishTutorialEvent.emit();
  }
} 